import { CategoryButton } from "../types/Category";

export const categories: CategoryButton[] = [
    { name: 'Farting' },
    { name: 'Scat' },
];

